import { render, staticRenderFns } from "./TwinSouls.vue?vue&type=template&id=1fdbecf4&"
import script from "./TwinSouls.vue?vue&type=script&lang=js&"
export * from "./TwinSouls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports